import { fetchProjectsAndTypesThunk } from './fetchProjectsAndTypesThunk';
export default fetchProjectsAndTypesThunk;
